// Turns Firebase Auth errors into messages an admin can act on, instead of
// showing raw text like "Firebase: Error (auth/invalid-credential)."
const MESSAGES = {
  // Wrong email or password. Firebase deliberately reports both the same way
  // (so attackers can't tell which emails exist), and so do we.
  'auth/invalid-credential':     'Incorrect email or password. Please try again.',
  'auth/wrong-password':         'Incorrect email or password. Please try again.',
  'auth/user-not-found':         'Incorrect email or password. Please try again.',
  'auth/invalid-email':          'Please enter a valid email address.',
  'auth/missing-password':       'Please enter your password.',
  'auth/user-disabled':          'This account has been disabled. Contact the site owner.',
  'auth/too-many-requests':      'Too many failed attempts. Please wait a few minutes and try again.',
  'auth/network-request-failed': 'Network error. Check your internet connection and try again.',
  'auth/popup-closed-by-user':   'Sign-in was cancelled.',
  'auth/cancelled-popup-request': 'Sign-in was cancelled.',
  'auth/popup-blocked':          'Your browser blocked the sign-in popup. Allow popups and try again.',
  'auth/unauthorized-domain':    'This website address is not authorised for sign-in.',
};

export function authErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  return MESSAGES[err?.code] || fallback;
}
